import BacktoTopCom from "../helpers/BackToTopCom";
import AboutSection from "./AboutSection";
import FeatureSection from "./FeatureSection";
import Hero from "./Hero";
import ServiceSection from "./ServiceSection";
import WorkProcessSection from "./WorkProcessSection";
import background from "../../assets/images/hero/modern-bg2.png";

function Home() {
    return (
        <div style={{
            backgroundImage: `url(${background})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
            minHeight: '100vh',
            position: 'relative'
        }}>
            {/* Dark overlay to make content pop */}
            <div style={{
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.65)',
                zIndex: 0
            }}></div>
            
            <div style={{ position: 'relative', zIndex: 1 }}>
                <Hero/>
                <ServiceSection/>
                <AboutSection/>
                <FeatureSection/>
                <WorkProcessSection/>
            </div>
            
            <div style={{ position: 'relative', zIndex: 9999 }}>
                <BacktoTopCom/>
            </div>
        </div>
    );
}

export default Home;
